export const selectNewsletterSubscribe = (state) => {
    return {
        ...state.userZone.newsletter.subscribe,
    };
};
